/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import _map from 'lodash/map';
import classNames from 'classnames/bind';
import * as styles from './LinkFarm.css';
import { metaDataElement, metaDataProperty } from '../../utils/cmPreviewMetaData';

const cx = classNames.bind(styles);

const LinkFarm = (props) => {
    const data = get(props, 'data', props);
    const { automationId } = data;
    const { teaserTitle, ctaLinks, urlHolder, altText } = data;
    const { isCMPreview } = props;

    const navSubHeaderBlockStyles = dt([
        'bg-white',
        'items-start',
        'justify-start',
        'flex',
        'flex-col',
    ]);
    const navSubHeaderStyles = dt([
        'border-b-0',
        'font-open-sans-bold',
        'text-normal',
        'pb-3',
        'capitalize',
        'text-left',
        'break-words',
        'text-black',
    ]);

    const renderTeaserTitle = () => {
        const { value } = urlHolder || {};
        return (
            <>
                {urlHolder ? (
                    <a
                        className={`${navSubHeaderStyles} ${dt(['hover:underline'])}`}
                        style={{ inlineSize: '100%' }}
                        href={value}
                        alt={altText}
                        title={altText}
                        data-automation-id="at-linkfarm-title"
                    >
                        {teaserTitle}
                    </a>
                ) : (
                    <div
                        className={navSubHeaderStyles}
                        style={{ inlineSize: '100%' }}
                        data-cm-metadata={isCMPreview && metaDataProperty('teaserTitle')}
                        data-automation-id="at-linkfarm-title"
                    >
                        {teaserTitle}
                    </div>
                )}
            </>
        );
    };
    const renderSubHeaderItems = (items) =>
        _map(items, (item) => {
            const { ctaText, ctaAltText } = item;
            const { value, openInNewTab, type } = item?.urlHolder || {};

            const targetWindow = openInNewTab ? '_blank' : '';
            const navSubHeaderItemLinkStyles = dt([
                'inline-block',
                'text-black',
                'font-open-sans-regular',
                'not-italic',
                'text-sm',
                'hover:underline',
                'max-h-[20px]',
            ]);
            const navSubHeaderListItemStyles = dt(['list-none', 'pb-3', 'leading-5']);

            return (
                <li
                    className={navSubHeaderListItemStyles}
                    key={ctaText}
                    data-cm-metadata={isCMPreview && metaDataProperty('ctaText')}
                    data-automation-id="at-linkfarm-list"
                >
                    <a
                        className={navSubHeaderItemLinkStyles}
                        data-automation-id="at-linkfarm-section-item"
                        data-type={type}
                        href={value}
                        target={targetWindow}
                        alt={ctaAltText}
                        title={ctaAltText}
                    >
                        {ctaText}
                    </a>
                </li>
            );
        });

    return (
        <div
            className={`${cx('linkFarmContainer')} ${dt(['lg:px-2'])} ${navSubHeaderBlockStyles}`}
            data-automation-id={automationId}
            data-cm-metadata={isCMPreview && metaDataElement(data)}
        >
            {renderTeaserTitle()}
            <ul data-automation-id="at-linkfarm-list">{renderSubHeaderItems(ctaLinks)}</ul>
        </div>
    );
};

/* istanbul ignore next */
LinkFarm.defaultProps = {
    automationId: 'link-farm',
    triggerNavigationClick: () => {},
};

LinkFarm.propTypes = {
    automationId: PropTypes.string,
    triggerNavigationClick: PropTypes.func,
};
export default LinkFarm;
